import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const OnboardingFirstSkill = () => {
  const navigate = useNavigate();
  const { user, setUser } = useAuth();
  const [loading, setLoading] = useState(false);

  const completeOnboarding = async (redirectPath) => {
    setLoading(true);
    try {
      // Mark onboarding as completed
      const response = await axios.patch(`${API_URL}/users/me`, {
        onboarding_completed: true
      });
      
      // Update user state
      setUser(response.data);
      
      toast.success('Welcome to Skillerate! 🎉');
      navigate(redirectPath);
    } catch (error) {
      console.error('Failed to complete onboarding:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F7EFE7] to-white dark:from-dark-bg dark:to-dark-card">
      <div className="max-w-2xl mx-auto text-center px-4">
        {/* Skillerate Icon */}
        <div className="flex justify-center mb-6">
          <img
            src="https://customer-assets.emergentagent.com/job_5cdedf29-6831-4187-8b3b-d6d324530c65/artifacts/vckerg2u_Skillerate%20Icon%20Only.svg"
            alt="Skillerate"
            className="h-16 w-16"
          />
        </div>
        {/* Progress indicator */}
        <div className="flex justify-center gap-2 mb-8">
          <div className="w-20 h-2 bg-gray-300 rounded-full"></div>
          <div className="w-20 h-2 bg-gray-300 rounded-full"></div>
          <div className="w-20 h-2 bg-[#E98341] rounded-full"></div>
        </div>
        
        <h2 className="text-4xl font-bold mb-4 text-[#3A1E10] dark:text-dark-text">
          Ready to create your first skill? 🚀
        </h2>
        <p className="text-xl text-[#6b7280] dark:text-dark-text-secondary mb-12">
          Start building with our visual editor, or explore skills from other creators
        </p>
        
        {/* Preview image placeholder */}
        <div className="mb-12 rounded-xl overflow-hidden shadow-lg bg-gradient-to-br from-[#E98341] to-[#c43408] p-12">
          <div className="text-white text-6xl mb-4">🎨</div>
          <h3 className="text-white text-2xl font-semibold mb-2">Visual Skill Builder</h3>
          <p className="text-white opacity-90">
            Create powerful Claude Skills with our intuitive drag-and-drop editor
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            onClick={() => completeOnboarding('/builder')}
            disabled={loading}
            className="px-8 py-6 bg-[#E98341] text-white text-lg font-semibold rounded-lg hover:bg-[#c43408] transition-colors"
          >
            {loading ? 'Loading...' : 'Create My First Skill'}
          </Button>
          <Button
            onClick={() => completeOnboarding('/dashboard')}
            disabled={loading}
            variant="outline"
            className="px-8 py-6 border-2 border-gray-300 text-[#3A1E10] text-lg font-semibold rounded-lg hover:bg-gray-50 transition-colors"
          >
            {loading ? 'Loading...' : 'Explore Skills First'}
          </Button>
        </div>
        
        <button
          onClick={() => navigate('/onboarding/profile')}
          className="text-sm text-[#6b7280] mt-6 hover:underline"
        >
          ← Back to profile
        </button>
        
        <p className="text-sm text-[#6b7280] mt-4">
          You can always create skills later from your dashboard
        </p>
      </div>
    </div>
  );
};

export default OnboardingFirstSkill;
